import { render, staticRenderFns } from "./AddManningHistory.vue?vue&type=template&id=6f1c4a34&scoped=true&"
import script from "./AddManningHistory.vue?vue&type=script&lang=js&"
export * from "./AddManningHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c4a34",
  null
  
)

export default component.exports